<template>
    <div class="icoButton" data-icoTarget="user" @click="parent.openConfigPanel()"></div>
</template>

<script>
    export default {
        name: 'ConfigPanelMixinMenu',
        inject: ['parent'],
    };
</script>
